<script setup lang="ts">
import type { VNode } from 'vue'

withDefaults(
  defineProps<{
    /** Lights the lamp; off, the lens shows as unlit glass. */
    lit?: boolean
    /** The light's colour: `blue` · `green`. */
    tone?: 'blue' | 'green'
    /** How strongly a lit lamp glows: `steady` · `bright`. */
    intensity?: 'steady' | 'bright'
  }>(),
  { lit: false, tone: 'blue', intensity: 'steady' },
)

defineSlots<{
  /** What the lens carries, such as a number or an icon. Several children stack in one place. */
  default(): VNode[]
}>()
</script>

<template>
  <span
    class="lamp size-12 text-caption-emphasized"
    :data-lit="lit ? 'true' : 'false'"
    :data-tone="tone"
    :data-intensity="intensity"
    data-lamp
    aria-hidden="true"
  >
    <span class="lamp__lens">
      <span class="lamp__light" />
      <span class="lamp__flare" data-lamp-part="flare" />
      <span class="lamp__content icon-2xs">
        <slot />
      </span>
    </span>
  </span>
</template>
